import { useNavigate, useSearchParams } from "react-router-dom";
import Navigation from "../../Components/Navbar";
import { useContext,useEffect, useState } from "react";
import api from "../../Components/Api/Api";
import Spinner from "../../Components/Spinner";
import { Button, Image } from "react-bootstrap";
import { UserContext } from '../../context/UserContext';

const Aprovacao = () => {
    const {user} = useContext(UserContext)
    const [orcamento, setOrcamento] = useState<any>('');
    const [filial_, setFilial] = useState<any>('');
    const [searchParams] = useSearchParams();  
    const [ready, setReady] = useState(false); 
    const [ShowLoading, setShowLoading] = useState(false)
    const [ipAddress, setIPAddress] = useState('')
    const [country, setCountry] = useState('')
    const [latitude, setLatitude] = useState('')
    const [longitude, setLongitude] = useState('')
    const [state, setState] = useState('')
    const navigate = useNavigate();
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agente": "PneusBrasil",
        "Accept": "*/*",
        'Authorization': `Basic ${credentials}`,
      }
    interface Itens {
        id: number;
        produto: string;
        prodescricao: string;
        quantidade: number;
        preco: number;
        pco_venda: number;
        pco_avista: number;
        promocao: number;
        autoriza: string;
        foto: any;
      }     
    const [_pro, set_Pro] = useState<Itens[]>([]);    
    const itens = (nOrcamento: any, nFilial: any) => {  
        setShowLoading(true)
        api.get('Itensaprovacao?filial='+nFilial+'&consulta='+nOrcamento,{headers})
        .then(response => {  
            if (response.data.Orcamento.length > 0 ){  
                    if (_pro.length < response.data.Orcamento.length){
                        for (let i = 0; i < response.data.Orcamento.length; i++) {
                            _pro.push({ id: Number(response.data.Orcamento[i]['id']), produto: response.data.Orcamento[i]['produto'], prodescricao: response.data.Orcamento[i]['descricao'], quantidade: response.data.Orcamento[i]['quantidade'],preco: response.data.Orcamento[i]['vlunitario'], pco_venda: response.data.Orcamento[i]['vlunitario'],pco_avista: 0, promocao: 0, autoriza: response.data.Orcamento[i]['autoriza'], foto: ''}) 
                        } 
                    } 
                    set_Pro(_pro) 
                    visualizar(nOrcamento)
                    setShowLoading(false)                
            }else{
                setShowLoading(false) 
                alert("Não foram encontrados itens aptos para aprovação!")  

            }                                 
        });                
    }    
    function visualizar(nOrcamento: any) {
        let it = [..._pro];
        for (let i = 0; i < it.length; i++) {           
        setTimeout(() => {
          api.get('Getimgdown?Orcamento='+nOrcamento+it[i].produto+'&foto='+it[i].produto,{headers})
          .then(response => {
                if (response.data.length > 0 ){    
                    const blob = new Blob([response.data], { type: 'image/jpg' })
                    it[i].foto = 'data:image/jpg;base64,'+response.data
                }                                   
          });
        }, 10 );      
      } 
      set_Pro(it);
    }
    const marcado = (el: any,index: any) => {
        let it = [..._pro];
        if(el.target.checked){
            it[index].autoriza = 'A'
        }else{
            it[index].autoriza = 'N'
        }
        set_Pro(it);
        console.log(_pro)
    } 
    const dadoscliente = () => {
        fetch('https://geolocation-db.com/json/')
        .then(response => response.json())
        .then(data => {
            setIPAddress(data.IPv4)
            setCountry(data.country_name)
            setLatitude(data.latitude)
            setLongitude(data.longitude)
            setState(data.state)
        })
        .catch(error => console.log(error))        
    } 
    const autorizar = () => {
        setShowLoading(true); 
        let nCont = 0
        let itens = ''
        for (let i = 0; i < _pro.length; i++) {  
            if(_pro[i].autoriza === "A"){
                nCont = nCont + 1
                itens = itens + ' - ' + _pro[i].produto
            }
        }      
                const url = 'ClienteAutoriza';
                // const headers = {
                //     'Content-Type': 'application/json;charset=UTF-8',
                //     "Access-Control-Allow-Origin": "*",
                //     "User-Agente": "PneusBrasil",
                //     "Accept": "*/*",
                //   }           
                let payload = ''
                payload += '{';
                payload += '"Empresa": "01",';
                payload += '"L2_NUM": "'+orcamento+'",';
                payload += '"Filial": "'+filial_+'",';               
                payload += '"Items": [';
                for (let i = 0; i < _pro.length; i++) {
                    payload += '{';
                    payload += '"L2_PRODUTO": "'+_pro[i]['produto']+'",';
                    payload += '"L2_ITEM": "'+addZeroes((_pro[i]['id']), 2)+'",';
                    if(_pro[i]['autoriza'] === 'S'){
                        payload += '"L2_XAPROVA": "N"';
                    }else{
                        payload += '"L2_XAPROVA": "'+_pro[i]['autoriza']+'"';
                    }
                    if(_pro.length > 1) {
                        if ((i + 1) < _pro.length){
                            payload += '},';
                        }
                    } 
                }
                payload += '}'; 
                payload += ']'; 
                payload += '}';
                console.log(payload)
                const data = payload 
                api.post(url,data, {headers})
                .then(function (response) {
                    if(response.data["info"] === 'Nao atualizado'){
                        alert("Orçamento não alterado, numero: "+ orcamento )  
                        console.log("Orçamento não alterado, numero: ", orcamento ) 
                        setShowLoading(false);             
                    }
                    if(response.data["info"] === 'atualizado'){
                        alert("Orçamento alterado, numero: "+ orcamento )  
                        console.log("Orçamento alterado, numero: ", orcamento )   
                        set_Pro([])
                        setShowLoading(false);  
                        if(itens !== '') {
                            alert("Itens autorizados" + nCont + " - " + itens)          
                        }else{
                            alert("Nem um item foi autorizado!")
                        }
                    }
    
                })
                .catch(function (error) {
                    console.error(error);
                    alert(error)
                    setShowLoading(false); 
                });            
    }        
    useEffect(( ) => {
        if (ready) return;
            let nOrcamento = searchParams.get('orcamento')
            let nFilial = searchParams.get('filial')
            setOrcamento(searchParams.get('orcamento'));
            setFilial(searchParams.get('filial'));
            itens(nOrcamento,nFilial)
            dadoscliente()
            setReady(true);       
         }, [ready, searchParams]);   
    return (
        <>
            <Navigation />
            <div className="container-lg">
                <div>
                    <span className="d-flex justify-content-center fs-3 text-primary">Aprovação de novos itens no orçamento nº {orcamento}</span>
                </div>
                <div className="m-0 list-group">
                    {_pro.map((iten: any,i: any) => (
                        <ul key={i} id={i} className="ms-0 ps-0">
                            <li className="list-group-item list-group-item-primary">{iten.produto} {iten.prodescricao} {iten.quantidade}</li>
                            <Image className="" style={{width: '100%', height: 450}} src={iten.foto}/>
                            <div className="input-group-text ms-0">
                                <label>Marque a caixa para aprovar o item:</label>
                                <input className="ms-0" type="checkbox" style={{width: 407, height: 30}} onClick={(e) => {marcado(e,i)}} />
                            </div>                            
                        </ul>
                    ))}                    
                </div>
                <div>
                    <span>Dados do usuario: Ip: {ipAddress} - {country} / {state} - Latitude: {latitude} Longitude: {longitude}</span>
                </div>
                <div className="mb-4 mt-4">
                    {_pro.length > 0 ?
                        (<Button className="me-5" size="lg" variant="outline-success " onClick={() => autorizar()}>Enviar</Button>) : ('')
                    }    
                </div>
            </div>
            <Spinner isLoading={ShowLoading} />
        </>
    )
}
function addZeroes(num :number, len: number) {
    var numberWithZeroes = String(num);
    var counter = numberWithZeroes.length;     
    while(counter < len) { 
      numberWithZeroes = "0" + numberWithZeroes;    
    counter++;  
    }
  
    return numberWithZeroes;
}
export default Aprovacao;